var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useLayoutEffect } from 'react';
export const useAsyncEffect = (asyncEffect, deps) => {
    useEffect(createAsyncEffectCallback(asyncEffect), deps);
};
export const useAsyncLayoutEffect = (asyncEffect, deps) => {
    useLayoutEffect(createAsyncEffectCallback(asyncEffect), deps);
};
const iife = (callback) => typeof callback === 'function' && callback();
const createAsyncEffectCallback = (asyncEffect) => () => {
    const destructor = iife(asyncEffect);
    return () => {
        if (!destructor)
            return;
        if (destructor instanceof Promise) {
            iife(() => __awaiter(void 0, void 0, void 0, function* () {
                const awaitedDestructor = yield destructor;
                if (typeof awaitedDestructor === 'function')
                    awaitedDestructor();
            }));
        }
        else if (typeof destructor === 'function') {
            iife(destructor);
        }
    };
};
